import http from './ajax';

const API_URL = {
  Banners: '/api/Banners', //大圖
  Advertisements: '/api/Advertisements' //廣告列表
};

class HomeApi extends http {
  //大圖
  Banners = async (params = {}) => {
    try {
      let url = `${API_URL.Banners}?count=${params.count}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('Banners', err);
    }
  };

  getBanners = (params = {}) => {
    return this.Banners(params);
  };

  //廣告
  Advertisements = async (params = {}) => {
    try {
      let url = params.count ? `${API_URL.Advertisements}/${params.count}` : API_URL.Advertisements;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('Advertisements', err);
    }
  };
  getAdvertisements = (params = {}) => {
    return this.Advertisements(params);
  };
}

export default new HomeApi();



// WEBPACK FOOTER //
// ./src/service/home.js